import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://139.224.28.156:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 响应拦截器
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error('API Error:', error.response.status, error.response.data);
    } else if (error.request) {
      console.error('Network Error:', error.request);
      error.response = {
        data: { error: '网络连接错误，请检查服务器是否运行' }
      };
    } else {
      console.error('Request Error:', error.message);
    }
    return Promise.reject(error);
  }
);

// 物品API - 只读
export const goodsAPI = {
  getAll: () => api.get('/goods'),
  getById: (id) => api.get(`/goods/${id}`),
};

// 设备API - 只读
export const equipmentsAPI = {
  getAll: () => api.get('/equipments'),
  getById: (id) => api.get(`/equipments/${id}`),
};

// 生产关系API - 只读
export const productionRelationsAPI = {
  getAll: () => api.get('/production-relations'),
  getById: (id) => api.get(`/production-relations/${id}`),
};

// 原料统计API
export const materialStatisticsAPI = {
  getStatisticsById: (goodId, quantity = 1) => {
    const params = {
      good_id: goodId,
      quantity,
    };
    

    return api.get('/material-statistics', { params });
  },
};

//合成路线API
export const productionRoutesAPI = {
  // 旧版API（可能有节点分离问题）
  getProductionRoutesById: (goodId, quantity = 1) => {
    const params = {
      good_id: goodId,
      quantity,
    };
    return api.get('/production-routes', { params });
  },
  // 新版API（推荐使用）
  getProductionRoutesV2: (goodId, quantity = 1) => {
    const params = {
      good_id: goodId,
      quantity,
    };
    return api.get('/production-routes-v2', { params });
  },
};

// 缓存管理API
export const cacheAPI = {
  getStats: () => api.get('/cache_stats'),
  clearAll: () => api.get('/clear_all_cache'),
};

// 系统API
export const systemAPI = {
  health: () => api.get('/health'),
  stats: () => api.get('/stats'),
};

export default api;